export default __webpack_public_path__ + "static/media/Aura-Egg__77.820b34e8.png";